const filterStateByBreakpointKey = (state = {}, breakpointKey) =>
  Object.entries(state).reduce((acc, [elementId, elementTargets]) => {
    const filteredTargets = Object.entries(elementTargets).reduce(
      (targetAcc, [target, breakpointBasedValue]) => {
        if (breakpointBasedValue?.[breakpointKey] === undefined) {
          return targetAcc;
        }

        return {
          ...targetAcc,
          [target]: breakpointBasedValue[breakpointKey],
        };
      },
      {}
    );

    if (Object.keys(filteredTargets).length === 0) {
      return acc;
    }

    return {
      ...acc,
      [elementId]: filteredTargets,
    };
  }, {});

export default filterStateByBreakpointKey;
